import { parseISO } from 'date-fns';
import { ReactElement, useState } from 'react';

import { toYearMonth } from '~/utils/date/date';
import { IArchivedMedicaidPlan, IMedicaidPlanClient } from '~/services/api/medicaidPlan/types';

import ArchivedPlanMonth from './ArchivedPlanMonth';
import MonthBar from './MonthBar';

import styles from './PlanEngagement.module.scss';

interface IArchivedPlanEngagementProps {
  plan: IArchivedMedicaidPlan;
  client: IMedicaidPlanClient;
}

const ArchivedPlanEngagement = ({ plan, client }: IArchivedPlanEngagementProps): ReactElement => {
  const [selected, setSelected] = useState(() =>
    toYearMonth(parseISO(plan.expirationDate || plan.archivedOn)),
  );

  return (
    <div className={styles.section}>
      <MonthBar selected={selected} onChange={setSelected} />
      <ArchivedPlanMonth
        key={`${selected.year}-${selected.month}`}
        planId={plan.id}
        client={client}
        selected={selected}
      />
    </div>
  );
};

export default ArchivedPlanEngagement;
